export default "assets/images/icons/print-ea90c048.svg";